import { FC } from "react";
import { Helmet } from "react-helmet";

const text = {
  pageTitle: "Some Logistics",
};

export const Meta: FC = () => {
  return (
    <Helmet>
      <title itemProp="name" lang="en">
        {text.pageTitle}
      </title>
    </Helmet>
  );
};
